import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#972200",
        secondary: "#010b51",
        accent: "#7D8CA3",
      },
    },
  },
});
